import { EIIState } from '@shared/enums/international-invoice.enums';

import { CONTACT_COMMENT, DEFAULT_SUBSTATE, INVOICE_STATE_MAP } from './invoices-my-international.constants';

export function getStatus(state: EIIState): string {
  return INVOICE_STATE_MAP[state]?.status;
}

export function getStatusComment(state: EIIState, subStateDocument: string): string {
  const statusComment = INVOICE_STATE_MAP[state]?.statusComment;

  if (statusComment) {
    return statusComment;
  }

  return getSubStateComment(state, subStateDocument);
}

export function getSubStateComment(state: EIIState, subState: string): string {
  const hasSubState = subState && subState !== DEFAULT_SUBSTATE;

  if (!hasSubState) {
    return state === EIIState.NOT_VERIFIED ? CONTACT_COMMENT : '';
  }

  return subState;
}

export function getRecipient(invoice: any): string {
  if (!!invoice?.CounterpartyTypeRecipient && invoice.CounterpartyTypeRecipient === 'Organization') {
    return invoice.CounterpartyRecipient;
  }

  return [invoice.CounterpartyRecipientFirstName, invoice.CounterpartyRecipientLastName].filter(Boolean).join(' ');
}
